'use client';

import React from 'react';
import ForgotPassword from '@/components/organisms/authentication/forgot-password';
import { AuthLayoutProps } from '@/components/organisms/authentication/types';
import useAccount from '@/lib/hooks/useAccount';
import { TasticProps } from '../../types';

const ForgotPasswordTastic = ({ data }: TasticProps<AuthLayoutProps>) => {
  const { requestPasswordReset } = useAccount();

  return <ForgotPassword requestPasswordReset={requestPasswordReset} {...data} />;
};

export default ForgotPasswordTastic;
